angular.module('impactx.cube').controller('SaveCubeCtrl', SaveCubeCtrl);

SaveCubeCtrl.$inject = ['CubeService', 'themeFactory', '$mdDialog', 'trns', 'cube'];

function SaveCubeCtrl(CubeService, themeFactory, $mdDialog, trns, cube) {
    var vm = this;
    vm.trns = trns;
    vm.cube = cube;

    this.getTheme = themeFactory.getTheme;

    this.save = function () {
        CubeService.save().then(vm.cancel)
    };

    this.cancel = $mdDialog.cancel;

}